<template>
    <van-popup
        :value.sync="selectUserListVisible"
        round
        position="bottom"
        :style="{ height: '408px' }"
        @click-overlay="handleClosePopup"
        v-if="selectUserListVisible"
    >
        <div class="select_company_box" v-if="selectUserListVisible">
            <div class="select_company_box_title">
                <span>已选人员（{{ selectUserListData.length }}）</span>
                <span class="clear_text" @click="handleClickClearAll">清空</span>
            </div>
            <ul>
                <li v-for="(item, index) in selectUserListData" :key="item.user_id">
                    <div class="img_box">
                        <img :src="item.avatar ? item.avatar : defaultImg" alt="" />
                    </div>
                    <div class="list_item_middle">
                        <p>
                            <span class="ellipsis">{{ item.name && item.name.value }}</span>
                        </p>
                        <p>
                            <template v-if="item.department_id">
                                {{
                                    item.department_id.text && item.department_id.text.length
                                        ? item.department_id.text
                                              .map((department) => department.department_name)
                                              .join("、")
                                        : "--"
                                }}
                            </template>
                            <template v-else>--</template>
                        </p>
                    </div>
                    <van-icon name="cross" @click="handleClickDelete(item, index)" />
                </li>
            </ul>
        </div>
    </van-popup>
</template>
<script>
export default {
    name: "SelectUserList",
    props: {
        selectUserListVisible: {
            type: Boolean,
            default: false,
        },
        selectUserListData: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
        };
    },
    methods: {
        handleClosePopup() {
            this.$emit("update:selectUserListVisible", false);
        },
        handleClickDelete(item) {
            this.$emit("changeItemSelete", { type: "item", data: item });
        },
        handleClickClearAll() {
            this.$emit("update:selectUserListData", []);
            this.$emit("changeItemSelete", { type: "all" });
        },
    },
};
</script>
<style lang="scss">
.van-popup {
    .select_company_box {
        height: 358px;
        background: rgba(247, 248, 250, 1);
        .select_company_box_title {
            position: relative;
            height: 48px;
            text-align: center;
            line-height: 48px;
            span:nth-child(1) {
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(51, 51, 51, 1);
            }
            .clear_text {
                position: absolute;
                top: 13px;
                right: 16px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(228, 65, 68, 1);
            }
        }
        ul {
            height: 310px;
            overflow-y: scroll;
            padding: 0 16px;
            li {
                padding: 0 10px 0 12px;
                height: 48px;
                border-radius: 6px;
                background: rgba(255, 255, 255, 1);
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 10px;
                .img_box {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    background-color: rgba(204, 204, 204, 1);
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                }
                .list_item_middle {
                    flex: 1;
                    overflow: hidden;
                    p:nth-child(1) {
                        font-size: 14px;
                        font-weight: 700;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(51, 51, 51, 1);
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    p:nth-child(2) {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 20px;
                        color: rgba(102, 102, 102, 1);
                    }
                }
                .van-icon-cross {
                    font-size: 24px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
}
</style>
